'use client'

import { useState, useEffect } from 'react'
/*import { QRCodeSVG } from "qrcode.react";
import { z } from "zod";*/
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/platform/v2/ui/dialog'
import { Button } from '@/components/platform/v2/ui/button'
import { Input } from '@/components/platform/v2/ui/input'
import { Label } from '@/components/platform/v2/ui/label'
import { ArrowLeft, Smartphone, FileText } from 'lucide-react'
import { toast } from '@/hooks/use-toast'
//import { VCENTRE_APP_URL as APP_URL } from "@/config/contact";

/*const formSchema = z.object({
  name: z.string().trim().min(2, "Введите имя").max(100),
  phone: z.string().trim().min(5, "Введите телефон").max(30),
});*/

type View = 'choose' | 'form' | 'qr'

interface Props {
    open: boolean
    onOpenChange: (open: boolean) => void
    triggerLabel?: string
    initialView?: View
    title?: string
}

export const DemoRequestDialog = ({ open, onOpenChange, initialView = 'choose', title = 'Запросить демонстрацию' }: Props) => {
    const [view, setView] = useState<View>(initialView)
    const [name, setName] = useState('')
    const [phone, setPhone] = useState('')
    const [submitting, setSubmitting] = useState(false)

    useEffect(() => {
        if (open) setView(initialView)
    }, [open, initialView])

    const reset = () => {
        setView(initialView)
        setName('')
        setPhone('')
    }

    const handleClose = (next: boolean) => {
        if (!next) reset()
        onOpenChange(next)
    }

    /*const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const parsed = formSchema.safeParse({ name, phone });
    if (!parsed.success) {
      toast({ title: "Проверьте данные", description: parsed.error.issues[0].message, variant: "destructive" });
      return;
    }
    setSubmitting(true);
    try {
      // Save lead locally — backend integration can be added later
      const leads = JSON.parse(localStorage.getItem("demo-leads") || "[]");
      leads.push({ ...parsed.data, createdAt: new Date().toISOString() });
      localStorage.setItem("demo-leads", JSON.stringify(leads));
      toast({ title: "Заявка отправлена", description: "Команда VCENTRE изучит обращение и свяжется с вами." });
      handleClose(false);
    } finally {
      setSubmitting(false);
    }
  };*/

    return (
        <Dialog open={open} onOpenChange={handleClose}>
            <DialogContent className="max-w-md">
                {view === 'choose' && (
                    <>
                        <DialogHeader>
                            <DialogTitle className="font-manrope">{title}</DialogTitle>
                            <DialogDescription className="font-manrope">
                                {
                                    /*APP_URL ? "Выберите удобный способ — оставьте заявку или откройте приложение." : */ 'Оставьте заявку — команда VCENTRE изучит задачу и свяжется с вами.'
                                }
                            </DialogDescription>
                        </DialogHeader>
                        <div className="grid gap-3 mt-2">
                            {/*APP_URL && <button
                onClick={() => setView("form")}
                className="block-active text-left p-5 hover:border-primary transition-colors flex items-start gap-4"
              >
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <FileText className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <div className="font-manrope text-foreground mb-1">Оставить заявку</div>
                  <div className="text-sm text-muted-foreground font-manrope">Имя и телефон — мы свяжемся с вами</div>
                </div>
              </button>*/}
                            <button
                                onClick={() => setView('qr')}
                                className="block-active text-left p-5 hover:border-primary transition-colors flex items-start gap-4"
                            >
                                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                                    <Smartphone className="w-5 h-5 text-primary" />
                                </div>
                                <div>
                                    <div className="font-manrope text-foreground mb-1">Перейти в приложение</div>
                                    <div className="text-sm text-muted-foreground font-manrope">QR-код или кнопка для открытия</div>
                                </div>
                            </button>
                        </div>
                    </>
                )}

                {view === 'form' && (
                    <>
                        <DialogHeader>
                            <button
                                onClick={() => setView('choose')}
                                className="flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground mb-2 font-manrope"
                            >
                                <ArrowLeft className="w-4 h-4" /> Назад
                            </button>
                            <DialogTitle className="font-manrope">Оставить заявку</DialogTitle>
                            <DialogDescription className="font-manrope">
                                Оставьте контакт — команда VCENTRE изучит обращение и свяжется с вами.
                            </DialogDescription>
                        </DialogHeader>
                        <form /*onSubmit={handleSubmit} */ className="space-y-4 mt-2">
                            <div className="space-y-2">
                                <Label htmlFor="demo-name">Имя</Label>
                                <Input
                                    id="demo-name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder="Ваше имя"
                                    maxLength={100}
                                    required
                                />
                            </div>
                            <div className="space-y-2">
                                <Label htmlFor="demo-phone">Телефон</Label>
                                <Input
                                    id="demo-phone"
                                    type="tel"
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                    placeholder="+7 ___ ___ __ __"
                                    maxLength={30}
                                    required
                                />
                            </div>
                            <Button type="submit" variant="site" disabled={submitting} className="w-full">
                                {submitting ? 'Отправка...' : 'Отправить заявку'}
                            </Button>
                        </form>
                    </>
                )}

                {view === 'qr' && (
                    <>
                        <DialogHeader>
                            <button
                                onClick={() => setView('choose')}
                                className="flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground mb-2 font-manrope"
                            >
                                <ArrowLeft className="w-4 h-4" /> Назад
                            </button>
                            <DialogTitle className="font-manrope">Перейти в приложение</DialogTitle>
                            <DialogDescription className="font-manrope">
                                Отсканируйте QR-код с телефона или откройте приложение здесь.
                            </DialogDescription>
                        </DialogHeader>
                        <div className="flex flex-col items-center gap-6 mt-2">
                            <div className="p-4 bg-white rounded-xl border border-border">
                                {/*<QRCodeSVG value={APP_URL} size={200} level="M" />*/}
                            </div>
                            <Button asChild variant="site" className="w-full">
                                <a href={/*APP_URL*/ '#'} target="_blank" rel="noopener noreferrer">
                                    Открыть приложение
                                </a>
                            </Button>
                        </div>
                    </>
                )}
            </DialogContent>
        </Dialog>
    )
}
